export interface EmailData {
    subject: string
    template: string
    recipient: string
    contentKey: string
}

export const updateEmailAddress = (domain: string) => ({
    subject: 'updateEmailSubjectKey',
    template: 'update-email-address',
    recipient: `book@wemolo.${domain}`,
    contentKey: 'updateEmailContentKey'
})

export const deleteEmailAddress = (domain: string) => ({
    subject: 'deleteEmailSubjectKey',
    template: 'delete-email-address',
    recipient: `book@wemolo.${domain}`,
    contentKey: 'deleteEmailContentKey'
})
